import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ControlVisitaDetalleContent } from './components/ControlVisitaDetalleContent';

export default function ControlVisitaDetalle() {
    return (
        <>
            <MainContent
                component={<ControlVisitaDetalleContent />}
                titulo='Detalle de control de Visitas'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
